export default function toDuration() {
  'ngInject';

  return function link(from, to, short) {
    const milliseconds = to - from;
    let minutes = milliseconds / 1000 / 60;
    const hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
    minutes = Math.floor(minutes);

    if (short) {
      return `${hours}h:${minutes}min`;
    }

    const hourLabel = hours ? `${hours} hour${hours > 1 ? 's' : ''}` : '';
    const minuteLabelSuffix = hours ? 'm' : ` minute${minutes > 1 ? 's' : ''}`;
    const minuteLabel = minutes ? `${hourLabel ? ' ' : ''}${minutes}${minuteLabelSuffix}` : '';
    return `${hourLabel}${minuteLabel}`;
  };
}
